export interface GuideSpec {
  name?: string;
  displaySize: string;
  recommendedSize: string;
  ratio: string;
  cropPosition?: string;
}

export interface TemplateGuide {
  guide: {
    imageType: string;
    specs: GuideSpec[];
  };
}

export const TEMPLATES_EDITOR_GUIDE: Record<string, TemplateGuide> = {
  'BASIC FULL IMAGE': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: 'Responsive (Full screen)',
          recommendedSize: '1125 x 2226 (3x)',
          ratio: '1:2',
          cropPosition: 'Top cropped (bottom aligned)'
        }
      ]
    }
  },
  'BASIC FULL COUNTDOWN': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: 'Responsive (Full screen)',
          recommendedSize: '1125 x 2436 (3x)',
          ratio: '1:2.2',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'BOTTOM SHEET IMAGE': {
    guide: {
      imageType: 'Single, Multiple(2~7)',
      specs: [
        {
          displaySize: 'Responsive (Bottom sheet)',
          recommendedSize: '1125 x 750 (3x)',
          ratio: '1.5:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'BOTTOM SHEET SLIDE': {
    guide: {
      imageType: 'Single, Multiple(2~7)',
      specs: [
        {
          displaySize: 'Responsive (Bottom sheet)',
          recommendedSize: '1125 x 750 (3x)',
          ratio: '1.5:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SLIDE FULL IMAGE': {
    guide: {
      imageType: 'Multiple(3~7)',
      specs: [
        {
          displaySize: '250 x 333',
          recommendedSize: '750 x 999 (3x)',
          ratio: '1:1.33',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'FULL DUAL IMAGE': {
    guide: {
      imageType: 'Dual(2)',
      specs: [
        {
          displaySize: '300 x 165',
          recommendedSize: '900 x 495 (3x)',
          ratio: '1.8:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'CAROUSEL SLIDE MODAL': {
    guide: {
      imageType: 'Multiple(3~10)',
      specs: [
        {
          name: 'Horizontal',
          displaySize: '270 x 180',
          recommendedSize: '810 x 540 (3x)',
          ratio: '1.5:1',
          cropPosition: 'Bottom cropped (top aligned)'
        },
        {
          name: 'Square',
          displaySize: '270 x 270',
          recommendedSize: '810 x 810 (3x)',
          ratio: '1:1',
          cropPosition: 'Bottom cropped (top aligned)'
        },
        {
          name: 'Vertical',
          displaySize: '270 x 348',
          recommendedSize: '810 x 1044 (3x)',
          ratio: '1:1.3',
          cropPosition: 'Bottom cropped (top aligned)'
        }
      ]
    }
  },
  'CHOICE BUTTON MODAL': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          name: 'Single',
          displaySize: '339 x 226~582',
          recommendedSize: '1017 x 678~1746 (3x)',
          ratio: 'Variable',
          cropPosition: 'Center cropped'
        },
        {
          name: 'Double',
          displaySize: '339 x 226~582',
          recommendedSize: '1017 x 678~1746 (3x)',
          ratio: 'Variable',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'MODAL SLIDE': {
    guide: {
      imageType: 'Multiple(3~7)',
      specs: [
        {
          displaySize: '192 x 192',
          recommendedSize: '576 x 576 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SLIDE MODAL IMAGE': {
    guide: {
      imageType: 'Multiple(3~7)',
      specs: [
        {
          displaySize: '256 x 256',
          recommendedSize: '768 x 768 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SIMPLE MODAL': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '290 x 435',
          recommendedSize: '870 x 1305 (3x)',
          ratio: '1:1.5',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'IMAGE BOTTOM SHEET': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: 'Responsive (Bottom sheet)',
          recommendedSize: '1125 x 780 (3x)',
          ratio: '1.4:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'AUTO MODAL SLIDE': {
    guide: {
      imageType: 'Multiple(3~7)',
      specs: [
        {
          displaySize: '192 x 192',
          recommendedSize: '576 x 576 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'AUTO SQUARE SLIDE': {
    guide: {
      imageType: 'Single, Multiple(2~10)',
      specs: [
        {
          displaySize: '339 x 339',
          recommendedSize: '1017 x 1017 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'RADIUS FULL COUNTDOWN': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '400 x 400',
          recommendedSize: '1200 x 1200 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'RADIUS MODAL SLIDE': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '240 x 160',
          recommendedSize: '720 x 480 (3x)',
          ratio: '1.5:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SIMPLE MODAL SLIDE': {
    guide: {
      imageType: 'Single, Multiple(2~7)',
      specs: [
        {
          displaySize: '300 x 300',
          recommendedSize: '900 x 900 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SIMPLE ICON MODAL': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '140 x 140',
          recommendedSize: '420 x 420 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SLIDE MODAL ROUND': {
    guide: {
      imageType: 'Single, Multiple(2~7)',
      specs: [
        {
          displaySize: '300 x 300',
          recommendedSize: '900 x 900 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'BOTTOM SLIDE UP': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '50 x 50',
          recommendedSize: '150 x 150 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'ALARM MODAL': {
    guide: {
      imageType: 'None',
      specs: []
    }
  },
  'COUPON BOTTOM SHEET': {
    guide: {
      imageType: 'None',
      specs: []
    }
  },
  'BASIC FULL ROULETTE': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          name: 'Result Image',
          displaySize: '224 x 224',
          recommendedSize: '672 x 672 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'BASIC SCRATCH MODAL': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '295 x 295',
          recommendedSize: '885 x 885 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'BASIC BOTTOM SHEET': {
    guide: {
      imageType: 'None',
      specs: []
    }
  },
  'CARD MODAL': {
    guide: {
      imageType: 'None',
      specs: []
    }
  },
  'FLOATING BOTTOM SHEET': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: 'Width 100%, Ratio 4:3',
          recommendedSize: '1200 x 900 (3x)',
          ratio: '4:3',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'CHOICE OPTION IMAGE': {
    guide: {
      imageType: 'Multiple(2~4)',
      specs: [
        {
          name: 'Double',
          displaySize: '300 x 150',
          recommendedSize: '900 x 450 (3x)',
          ratio: '2:1',
          cropPosition: 'Center cropped'
        },
        {
          name: 'Quad',
          displaySize: '150 x 150',
          recommendedSize: '450 x 450 (3x)',
          ratio: '1:1',
          cropPosition: 'Center cropped'
        }
      ]
    }
  },
  'SIMPLE CARD MODAL': {
    guide: {
      imageType: 'Multiple(1~10)',
      specs: [
        {
          displaySize: '314 x auto (max 582)',
          recommendedSize: '942 x 1746 (3x)',
          ratio: 'Variable',
          cropPosition: 'Bottom cropped (top aligned)'
        }
      ]
    }
  },
  'TRANSPARENT BOTTOM SHEET': {
    guide: {
      imageType: 'Single',
      specs: [
        {
          displaySize: '150 x 150',
          recommendedSize: '450 x 450 (3x)',
          ratio: '1:1',
          cropPosition: 'No crop (stretched)'
        }
      ]
    }
  }
};
